// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Calendar_calendar__1ttq9"};